import React, { useReducer } from "react";
import FriendContext from "./friendContext";
import friendReducer from "./friendReducer";
import { API_BASE, apiErrorMessage, authedFetch } from "../../utils/api";

import {
  ADD_FRIEND,
  ADD_FRIEND_ERROR,
  GET_FRIENDS,
  GET_FRIENDS_ERROR,
  REMOVE_FRIEND,
  REMOVE_FRIEND_ERROR,
  GET_FOLLOWERS,
  GET_FOLLOWERS_ERROR,
  GET_FEED_REVIEWS,
  GET_FEED_REVIEWS_ERROR,
  GET_FEED_TRIPS,
  GET_FEED_TRIPS_ERROR,
} from "../types";

const FriendState = (props) => {
  const initialState = {
    friends: [],
    loading: true,
    message: null,
    changed: false,
    followers: [],
    followersPage: 1,
    followersTotal: 0,
    followersHasMore: false,
    feedReviews: [],
    feedReviewsPage: 1,
    feedReviewsTotal: 0,
    feedReviewsHasMore: false,
    feedTrips: [],
    feedTripsPage: 1,
    feedTripsTotal: 0,
    feedTripsHasMore: false,
  };

  const [state, dispatch] = useReducer(friendReducer, initialState);

  const getFriends = async () => {
    const res = await authedFetch(`${API_BASE}/following`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
    const res_json = await res.json();
    if (res.ok) {
      dispatch({ type: GET_FRIENDS, payload: res_json });
    } else {
      dispatch({ type: GET_FRIENDS_ERROR, payload: apiErrorMessage(res_json) });
    }
  };

  const addFriend = async (friendId) => {
    const formData = new FormData();
    formData.append("friend_ids", friendId);
    const res = await authedFetch(`${API_BASE}/following/add`, {
      method: "POST",
      body: formData,
    });
    const res_json = await res.json();
    if (res.ok) {
      dispatch({ type: ADD_FRIEND, payload: res_json });
    } else {
      dispatch({ type: ADD_FRIEND_ERROR, payload: apiErrorMessage(res_json) });
    }
  };

  const removeFriend = async (friendId) => {
    const formData = new FormData();
    formData.append("friend_ids", friendId);
    const res = await authedFetch(`${API_BASE}/following/remove`, {
      method: "POST",
      body: formData,
    });
    const res_json = await res.json();
    if (res.ok) {
      dispatch({ type: REMOVE_FRIEND, payload: res_json });
    } else {
      dispatch({ type: REMOVE_FRIEND_ERROR, payload: apiErrorMessage(res_json) });
    }
  };

  const getFollowers = async (page = 1) => {
    const res = await authedFetch(`${API_BASE}/followers?page=${page}&page_size=20`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
    const res_json = await res.json();
    if (res.ok) {
      dispatch({ type: GET_FOLLOWERS, payload: res_json });
    } else {
      dispatch({ type: GET_FOLLOWERS_ERROR, payload: apiErrorMessage(res_json) });
    }
  };

  const getFeedReviews = async (page = 1) => {
    const res = await authedFetch(`${API_BASE}/feed/reviews?page=${page}&page_size=6`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
    const res_json = await res.json();
    if (res.ok) {
      dispatch({ type: GET_FEED_REVIEWS, payload: res_json });
    } else {
      dispatch({ type: GET_FEED_REVIEWS_ERROR, payload: apiErrorMessage(res_json) });
    }
  };

  const getFeedTrips = async (page = 1) => {
    const res = await authedFetch(`${API_BASE}/feed/trips?page=${page}&page_size=3`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
    const res_json = await res.json();
    if (res.ok) {
      dispatch({ type: GET_FEED_TRIPS, payload: res_json });
    } else {
      dispatch({ type: GET_FEED_TRIPS_ERROR, payload: apiErrorMessage(res_json) });
    }
  };

  return (
    <FriendContext.Provider
      value={{
        friends: state.friends,
        loading: state.loading,
        followers: state.followers,
        followersPage: state.followersPage,
        followersTotal: state.followersTotal,
        followersHasMore: state.followersHasMore,
        feedReviews: state.feedReviews,
        feedReviewsPage: state.feedReviewsPage,
        feedReviewsTotal: state.feedReviewsTotal,
        feedReviewsHasMore: state.feedReviewsHasMore,
        feedTrips: state.feedTrips,
        feedTripsPage: state.feedTripsPage,
        feedTripsTotal: state.feedTripsTotal,
        feedTripsHasMore: state.feedTripsHasMore,
        getFriends,
        addFriend,
        removeFriend,
        getFollowers,
        getFeedReviews,
        getFeedTrips,
      }}
    >
      {props.children}
    </FriendContext.Provider>
  );
};

export default FriendState;
